/* global $ */

const journeyHighlights = {
  initialize() {
    this.$node = $('.js-journey-highlights');

    if (!this.$node.length) {
      return;
    }

    this.$node.on('afterChange init reInit lazyLoaded', () => {
      this.handleRatios();
    });

    this.$node.on('load', 'img', () => {
      this.handleRatios();
    });

    $(window).on('resize', () => {
      this.handleRatios();
    });

    this.handleRatios();
  },

  handleRatios() {
    const $slidersWithRatios = this.$node.filter('[data-image-ratio]');

    $slidersWithRatios.toArray().forEach((slider) => {
      const ratio = parseFloat(slider.dataset.imageRatio);
      const width = slider.offsetWidth;

      const arrows = Array.prototype.slice.call(slider.querySelectorAll('.slick-arrow'));
      const dots = slider.querySelector('.slick-dots');

      arrows.forEach((arrow) => {
        arrow.style.top = `${(width * ratio) / 2}px`;
      });

      if (dots) {
        dots.style.bottom = 'auto';
        dots.style.top = `${width * ratio}px`;
      }
    });
  },
};

export default journeyHighlights;
